<template>
    <div class="window-wrapper" v-show="visible">
        <div class="window exit-window" v-show="visible">
            <div class="window-head">
                <div class="title">Выйти
                    <span class="close"
                          @click="closeWindow"><img src="@/image/close.png"></span>
                </div>
            </div>
            <div class="window-body">
                <div class="text">Вы действительно хотите выйти из учетной записи?</div>
                <div class="center two-buttons">
                    <button class="button red-button" type="button"
                            @click="logout">Выйти</button>
                    <button class="button blue-button" type="button"
                            @click="closeWindow">Отмена</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from '@/utils';

    export default {
        name: "LogoutWindow",

        props: ['visible'],

        data() {
            return {}
        },

        watch: {
            visible(val) {
                utils.changePopupWindowVisibility(val);
            }
        },

        computed: {},

        methods: {
            logout() {
                this.$emit('close-window', {
                    success: true
                });

                this.$nextTick(() => {
                    this.$store.dispatch('logout');
                    this.$router.push({name: 'Login'});
                });
            },

            closeWindow() {
                this.$emit('close-window', {
                    success: null
                });
            }
        },

        destroyed() {
            utils.changePopupWindowVisibility(false);
        }
    }
</script>